import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Certificates from "../../../App/Components/Certificates/Certificates";
import Loader from "../../../Components/Loader/Loader";
import getConfig from "../../../aws-config";

export default function PublicCredentials() {
	const { id } = useParams<{ id: string }>();
	const [certificates, setCertificates] = useState([]);
	const [name, setName] = useState("");
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				// Perform your data fetching here using the id

				const response = await fetch(`${getConfig().api_url}v1.2/shared-credentials?id=${id}`);
				const result = await response.json();
				console.log(result);
				// Update the state with the fetched data
				setCertificates(result.certificates);
				setName(result.name);
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [id]);
	return <React.Fragment>{loading ? <Loader /> : <Certificates certificates={certificates} name={name} />}</React.Fragment>;
}
